import { BaseEntity } from "yt-ng-framework";

export class FakDokumentStavkaView extends BaseEntity{
    constructor(){
        super();
    }

    VrstaStavki: string;
    Tarifa: string;
    Kolicina: number;
    Cena: number;
    RabatProc: number;
    Stopa: number;
    Opis: string;
    Osnovica: number;
    Porez: number;
    Ukupno: number;
    RabatVred: number;  
    JedinicaMere: string; 
    VrednostPreRabataStavke: number;
    RabatStavke: number;
    OsnovicaStavke: number;
    PdvStavke: number;
    VrednostStavke: number;   
// 22.08.2023    
//    Vrednost: number;
//    UkRabat: number;

//CenaSaPDV: number; 
    // IznosPdv: number;

    Deserialize(input:any){
        this.ID=input.ID;
        this.VrstaStavki=input.VrstaStavki;
        this.Tarifa=input.Tarifa;
        this.Kolicina = input.Kolicina;
        this.Cena=input.Cena;
        this.RabatProc=input.RabatProc;
        this.Stopa=input.Stopa;
        this.Opis=input.Opis;
        this.Osnovica=input.Osnovica;
        this.Porez = input.Porez;
        this.Ukupno=input.Ukupno;
        this.RabatVred = input.RabatVred;
        this.JedinicaMere = input.JedinicaMere;
        this.VrednostPreRabataStavke = input.VrednostPreRabataStavke;
        this.RabatStavke = input.RabatStavke;
        this.OsnovicaStavke = input.OsnovicaStavke;
        this.PdvStavke = input.PdvStavke;
        this.VrednostStavke = input.VrednostStavke;
// 22.08.2023        
//        this.Vrednost = input.Vrednost;
//        this.UkRabat = input.UkRabat;
        // this.IznosPdv=input.IznosPdv;
        
        return this;
    }

    Serialize(input:FakDokumentStavkaView){
        return input;
    }
}